import React, { useRef, useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CommentsRender from "./CommentsRender/index";

import { addRecomment, loadDetailPost } from "redux/modules/postSlice";

import { DetailLine } from "../../common/commonStyle";
import {
  FirstContainer,
  Container,
  DetailComments,
} from "./CreateRecommentStyle";

function CreateRecomment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const postId = location.state.postId;
  const commentId = location.state.commentId;

  const detailPost = useSelector((state) => state.post.detailPost);
  //const mainPosts = useSelector((state) => state.post.mainPosts);
  //const post = mainPosts.filter((post) => post.boardId === parseInt(postId))[0];
  const comment = detailPost.comments?.filter(
    (comment) => comment.commentId === commentId,
  )[0];

  const textareaRef = useRef(null);
  const [focus, setFocus] = useState("blur");
  const [recommentLength, setRecommentLength] = useState(0);

  console.log("ㅎㅎㅎ", postId, detailPost);
  useEffect(() => {
    dispatch(loadDetailPost(postId));
    textareaRef.current.focus();
  }, [dispatch]);

  const onChangeComment = useCallback((e) => {
    setRecommentLength(e.target.value.length);

    // 자동높이조절
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, []);

  // 답글 등록
  const onClickComment = useCallback(() => {
    const payload = {
      commentId: comment.commentId,
      content: textareaRef.current.value,
    };

    dispatch(addRecomment(payload))
      .unwrap()
      .then((res) => {
        dispatch(loadDetailPost(detailPost.boardId));
        // navigate(`/boards/${post.boardId}/comments/${comment.commentId}`);
        navigate(-1);
        textareaRef.current.value = "";
        textareaRef.current.blur();
        setRecommentLength(0);
        setFocus("blur");
      });
  }, [navigate, dispatch, detailPost.boardId]);

  return (
    <FirstContainer>
      <Container>
        <div>
          <img
            onClick={() => navigate(-1)}
            src="/img/arrowBack.svg"
            alt="arrow back"
          />
          <h1>답글 작성하기</h1>
        </div>
      </Container>

      <DetailLine />

      <DetailComments>
        <CommentsRender
          post={detailPost}
          comment={comment}
          textareaRef={textareaRef}
        />

        {/* 답글입력창 */}
        <div className="commentsMargin">
          <div className="inputComments">
            <textarea
              ref={textareaRef}
              className={focus}
              type="text"
              rows="1"
              maxLength="80"
              placeholder="답글을 입력해 주세요"
              onFocus={() => setFocus("focus")}
              onBlur={() => setFocus("blur")}
              onChange={(e) => onChangeComment(e)}
            />
            {(focus === "focus" || recommentLength > 0) && (
              <div
                className="textareaAside"
                onClick={() => {
                  textareaRef.current.focus();
                }}
              >
                <div>{recommentLength}/80</div>
                <button
                  className={recommentLength > 0 ? "orange" : "black"}
                  onClick={onClickComment}
                >
                  등록
                </button>
              </div>
            )}
          </div>
        </div>
      </DetailComments>
    </FirstContainer>
  );
}

export default CreateRecomment;
